import {
  type AxiosRequestConfig,
  httpClient,
  type Path,
} from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';

export interface DraftResponse {
  _id: string;
  service_id: string;
  user_id: string;
  path: Path;
  requests: Request[];
  payment_method: string;
  total_pay: number;
  promo_code: string;
  remarks: string;
  idle_until: number;
  suggest_promotion: boolean;
  inserted_time: number;
  updated_time: number;
}

export const getDraftDetailFn = async (
  id: string,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.get<DraftResponse>(
    apiRoutes.draft.getDraftDetail(id),
    config
  );
  return response.data;
};
